// Marker set just before a post-install page reload, so the fresh load knows it likely follows an
// extension install. "Pending" because neither reload path proves it — consumers must still confirm
// the extension is present. sessionStorage so the signal doesn't outlive the tab.
//
// Written on every install path, read by nobody since lite's tour stopped playing itself: the first-launch
// glow on the Getting Started card is what consumes it next (UNS-5263).

const INSTALL_PENDING_KEY = 'unscreenExtensionJustInstalled';

// Marker on the extension's own post-install redirect (forwarded by UserRouterController). Read from the
// URL, not the server, so it adds nothing per-visitor to lite's CDN-cached HTML.
const INSTALL_PARAM = 'installed';

export function arrivedFromInstall() {
  return new URLSearchParams(window.location.search).get(INSTALL_PARAM) === '1';
}

// Strip it once read: the marker alone authorizes a conversion, so a reload or a bookmark of the
// landing URL must not be able to replay it.
export function clearInstallMarker() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(INSTALL_PARAM)) return;

  url.searchParams.delete(INSTALL_PARAM);
  window.history.replaceState(window.history.state, '', url);
}

// Storage throws when blocked; losing the signal is fine, breaking the reload isn't.
export function markExtensionInstallPending() {
  try {
    sessionStorage.setItem(INSTALL_PENDING_KEY, '1');
  } catch {
    // See above.
  }
}

// Consume once acted on, so a later load in the same tab doesn't re-arm off it.
export function clearExtensionInstallPending() {
  try {
    sessionStorage.removeItem(INSTALL_PENDING_KEY);
  } catch {
    // See above.
  }
}

export function extensionInstallPending() {
  try {
    return sessionStorage.getItem(INSTALL_PENDING_KEY) === '1';
  } catch {
    return false;
  }
}
